export default __webpack_public_path__ + "static/media/ikizdere-nehri-nafting-arkadaslar.adc1d517.jpg";